import { render, staticRenderFns } from "./UnsubscribeReasonModal.vue?vue&type=template&id=014e8dd1&scoped=true&"
import script from "./UnsubscribeReasonModal.vue?vue&type=script&lang=ts&"
export * from "./UnsubscribeReasonModal.vue?vue&type=script&lang=ts&"
import style0 from "./UnsubscribeReasonModal.vue?vue&type=style&index=0&id=014e8dd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e8dd1",
  null
  
)

export default component.exports